import { render, staticRenderFns } from "./ImagesLoader.vue?vue&type=template&id=70fe490e&scoped=true"
import script from "./ImagesLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImagesLoader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ImagesLoader.vue?vue&type=style&index=0&id=70fe490e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe490e",
  null
  
)

export default component.exports